import { AppointmentStatus } from "types";

const STATUSES: Record<string, AppointmentStatus> = {
  Booked: "upcoming",
  Patient_missed: "missed",
  Practitioner_missed: "missed",
  Both_missed: "missed",
  Patient_cancelled: "cancelled",
  Practitioner_cancelled: "cancelled",
};

const transformAppointmentStatus = (status: string): AppointmentStatus => {
  return STATUSES[status] || status.toLowerCase();
};

export { transformAppointmentStatus };
